<template>
    <div>
        <div class="vx-row w-full mt-3" v-if="competitorsLength > 0">
            <vx-card v-if="competitorsLength <= 0">
                <ul>
                <li>
                    <span class="vx-row">
                    <span class="vx-col"><vs-icon icon="warning" size="small" color="primary" /></span>
                    <span class="vx-col">Attention vous n'avez pas défini de concurrents. <span v-if="$acl.check('accountmanager')" @click="showCompetitorsPopup" style="width: 37px;" class="hvr-underline hvr-underline-out">(Editer les concurrents)</span></span>
                    </span>
                    </li>
                </ul>
            </vx-card>
            </div>
            <div class="vx-row w-full mt-3" v-if="topKeywordsLength > 0">
            <vx-card>
                <div class="vx-row mb-2">
                <div class="vx-col">
                    <h4 class="pb-2">{{societyName + ' VS. Concurrents '}}<span v-if="$acl.check('accountmanager')" @click="showCompetitorsPopup" style="width: 37px;" class="hvr-underline hvr-underline-out">(Editer les concurrents)</span></h4>
                </div>
                </div>
                <div class="vx-row w-full" v-if="topKeywordsLength > 0">
                <div class="vx-col w-full ml-3">
                    <vx-card>
                    <vs-tabs>
                        <vs-tab :label="stackedBarChartOptionsTopKeywordsCompetitorsComparison ? 'Positions comparées Top 100' + stackedBarChartOptionsTopKeywordsCompetitorsComparison.date : 'Positions comparées Top 100'">
                        <div id="competitor-compared-positions" ref="competitor-compared-positions" class="vs-con-loading__container">
                            <apexchart
                                v-if="stackedBarChartOptionsTopKeywordsCompetitorsComparison && stackedBarChartOptionsTopKeywordsCompetitorsComparison.chartOptions && stackedBarChartOptionsTopKeywordsCompetitorsComparison.series"
                                ref="monthlyTKCCChart"
                                type="bar"
                                height="350"
                                :options="stackedBarChartOptionsTopKeywordsCompetitorsComparison.chartOptions"
                                :series="stackedBarChartOptionsTopKeywordsCompetitorsComparison.series"
                            ></apexchart>
                        </div>
                        </vs-tab>
                        <vs-tab label="Valeur totale du SEO des Top Keywords">
                        <div id="competitor-seo-value" ref="competitor-seo-value" class="vs-con-loading__container">
                            <!-- <div class="vx-row">
                                <div class="vx-col">
                                <h4 class="pt-3">Valeur totale du SEO des Top Keywords</h4>
                                </div>
                                <div class="vx-col">
                                <vx-tooltip text="Valeur totale du SEO du site calculée en fonction de la position sur Google, du CTR estimé, du CPC Google Ads, et des volumes de recherche mensuels pour tous les Top Keywords.">
                                    <vs-avatar text="?" style="cursor: default;"></vs-avatar>
                                </vx-tooltip>
                                </div>
                            </div> -->
                            <apexchart v-if="topKeywordsSEOValueOptions && topKeywordsSEOValueOptions.series" height="350" type="bar" :options="topKeywordsSEOValueOptions" :series="topKeywordsSEOValueOptions.series"></apexchart>
                        </div>
                        </vs-tab>
                    </vs-tabs>

                    </vx-card>
                </div>
                </div>
                <div class="vx-row w-full" v-if="topKeywordsLength > 0 && filteredtopKeywordsSERPComparison">
                <div class="vx-col w-full ml-3 vs-con-loading__container" id="competitor-positions-evolution" ref="competitor-positions-evolution">
                    <vx-card class="mt-8">
                    <div class="vx-row">
                        <div class="vx-col">
                        <h4 class="pt-3">Evolution des positions des Top Keywords</h4>
                        </div>
                        <div class="vx-col">
                        <vx-tooltip text="Cliquez sur chaque mots-clés pour connaître l’évolution chronologique de la position du site et celle des concurrents.">
                            <vs-avatar text="?" style="cursor: default;"></vs-avatar>
                        </vx-tooltip>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col pt-2">
                        <span>Nombre de keywords affichés : </span>
                        </div>
                        <div class="vx-col">
                        <vs-select
                            autocomplete
                            v-model="maxRowMultiplicatorTKSERP"
                            class="select-large pb-4"
                        >
                            <vs-select-item
                            :key="index"
                            :value="item"
                            :text="item"
                            v-for="(item, index) in pageNumberOptions"
                            class="w-full"
                            />
                        </vs-select>
                        </div>
                        <div class="vx-col pt-2">
                        <span>Recherche par keyword : </span>
                        </div>
                        <div class="vx-col">
                        <vs-input class="inputx" placeholder="Keyword" v-model="keywordSearchInput"  />
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col py-2">
                        <strong>Nombre de top keywords : {{ totalRowTKSERP }}</strong>
                        </div>

                        <div class="vx-col py-2">
                        <strong>Volume de recherche total : {{ totalVolumeFilteredKeywordsCompetitors }}</strong>
                        </div>
                    </div>

                    <vs-table ref="topKeywordsSERPComparisonTable" stripe auto-resize hoverFlat noDataText="" :data="[]">
                        <template>
                        <thead>
                            <vs-th sort-key="keyword" style="height: 30px; text-align: left;">
                                <div @click="sortTable('topKeywordsSERPComparisonTable', 'keyword', 'serpComparisonSortKey')">
                                    Mots-clés
                                </div>
                            </vs-th>
                            <vs-th sort-key="volume" class="px-2" style="height: 30px; text-align: right; width: 60px !important;">
                                <div @click="sortTable('topKeywordsSERPComparisonTable', 'volume', 'serpComparisonSortKey')">
                                    <vs-spacer />
                                    Recherches mensuelles
                                </div>
                            </vs-th>
                            <vs-th  sort-key="cpc" class="px-2" style="height: 30px; text-align: right; width: 60px !important;">
                                <div @click="sortTable('topKeywordsSERPComparisonTable', 'cpc', 'serpComparisonSortKey')">
                                    <vs-spacer />
                                    CPC Google
                                </div>
                            </vs-th>
                            <vs-th sort-key="kd" class="px-2" style="height: 30px; width: 60px !important;">
                                <div @click="sortTable('topKeywordsSERPComparisonTable', 'kd', 'serpComparisonSortKey')">
                                    <vx-tooltip text="Keyword Difficulty/Competition Index">
                                    <span class="pl-3">KD</span>
                                    </vx-tooltip>
                                </div>
                            </vs-th>
                            <vs-th style="width: 10px !important;"></vs-th>
                            <vs-th :sort-key="row" :key="index" v-for="(row, index) of filteredtopKeywordsSERPComparison.domains" style="width: auto; height: 30px;">
                                <div @click="sortTable('topKeywordsSERPComparisonTable', row, 'serpComparisonSortKey')">
                                    <vx-tooltip :text="trimExtensionAndPrefix(row)" style="width: 100%; text-align:center;">
                                        {{textWrap(trimExtensionAndPrefix(row), 10)}}
                                    </vx-tooltip>
                                </div>
                            </vs-th>
                        </thead>

                        <vs-tr :key="index" v-for="(row, index) of filteredtopKeywordsSERPComparison.keywords">
                            <vs-td>
                                <strong @click="selectEvolutionKeyword(index)" class="hvr-underline hvr-underline-out">{{index}}</strong>
                                <a :href="convertKeywordToGoogleSearchUrl(index)" target='_blank' class="hvr-underline hvr-underline-out"><vs-icon icon="open_in_new" size="small" style="font-size: 1rem; height: 0.8rem;" /></a>
                            </vs-td>

                            <vs-td class="td_padding_top_bottom_small" style="justify-content: right;">
                                <strong style="padding-left: 5px; padding-right: 5px; float: right;">{{ filteredtopKeywordsSERPComparison.keywords_info[index] && filteredtopKeywordsSERPComparison.keywords_info[index].volume ? formatThousandNumb(filteredtopKeywordsSERPComparison.keywords_info[index].volume) : 0 }}</strong>
                            </vs-td>
                            <vs-td class="td_padding_top_bottom_small" style="justify-content: right;">
                                <strong style="padding-left: 5px; padding-right: 5px; float: right;">{{ filteredtopKeywordsSERPComparison.keywords_info[index] && filteredtopKeywordsSERPComparison.keywords_info[index].cpc ? formatThousandNumb(filteredtopKeywordsSERPComparison.keywords_info[index].cpc) : 0 }}€</strong>
                            </vs-td>
                            <vs-td class="td_padding_top_bottom_small" style="justify-content: right;">
								<vs-chip
                                    style="color: white; border-radius: 8px; width: 35px; margin-right: 20px;"
                                    :color="computeResultColorFromDifferenceKD(61, 219, 80, 252, 186, 3, 204, 41, 87, filteredtopKeywordsSERPComparison.keywords_info[index].kd)"
                                >{{ filteredtopKeywordsSERPComparison.keywords_info[index].kd }}</vs-chip>
                            </vs-td>
                            <vs-td></vs-td>
                            <vs-td :key="indexDomains" v-for="(row, indexDomains) of filteredtopKeywordsSERPComparison.domains" class="td-chips">
                                <span style="display: inline-block;">
                                <vs-spacer />
                                <!-- Chip superior to previous and previous == 0 -->
                                <vs-chip v-if="filteredtopKeywordsSERPComparison.keywords[index][row] && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] > filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 2] && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 2] == 0"
                                style="color: white; border-radius: 8px;width: 65px;" :color="computeResultColorFromDifference(8, 176, 185,filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1], true)">
                                    <span v-if="filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] == 101" style="font-size: 1rem;"><vs-icon icon="schedule" size="small" color="primary" /></span>
                                    <span v-else style="font-size: 1rem;">{{ filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] > 100 ? '100+' : filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] }}</span>
                                    <vs-icon icon-pack="feather" icon="icon-arrow-up" size="small" color="white" style="font-size: 1rem; height: 0.8rem;"></vs-icon>
                                </vs-chip>


                                <!-- Chip == 0 and previous == -1 -->
                                <vs-chip v-else-if="filteredtopKeywordsSERPComparison.keywords[index][row] && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] === 0 && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 2] == -1" style="color: white; border-radius: 8px;width: 65px;" color="grey">
                                    ABS
                                </vs-chip>


                                <!-- Chip superior to previous and previous == -1 -->
                                <vs-chip v-else-if="filteredtopKeywordsSERPComparison.keywords[index][row] && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] > filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 2] && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 2] === -1"
                                style="color: white; border-radius: 8px;width: 65px;" :color="computeResultColorFromDifference(8, 176, 185,filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1], true)">
                                    <span v-if="filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] == 101" style="font-size: 1rem;"><vs-icon icon="schedule" size="small" color="primary" /></span>
                                    <span v-else style="font-size: 1rem;">{{ filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] > 100 ? '100+' : filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] }}</span>
                                </vs-chip>


                                <!-- Chip superior to previous and previous != 0 -->
                                <vs-chip v-else-if="filteredtopKeywordsSERPComparison.keywords[index][row] && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] > filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 2] && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 2] != 0"
                                style="color: white; border-radius: 8px;width: 65px;" :color="computeResultColorFromDifference(8, 176, 185,filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1], true)">
                                    <span v-if="filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] == 101" style="font-size: 1rem;"><vs-icon icon="schedule" size="small" color="primary" /></span>
                                    <span v-else style="font-size: 1rem;">{{ filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] > 100 ? '100+' : filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] }}</span>
                                    <vs-icon icon-pack="feather" icon="icon-arrow-down" size="small" color="white" style="font-size: 1rem; height: 0.8rem;"></vs-icon>
                                </vs-chip>


                                <!-- Chip inferior to previous and is === 0 -->
                                <vs-chip v-else-if="filteredtopKeywordsSERPComparison.keywords[index][row] && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] < filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 2] && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] === 0" style="border-radius: 8px;width: 65px;" color="grey">
                                    ABS
                                </vs-chip>


                                <!-- Chip inferior to previous and is == -1 -->
                                <span v-else-if="filteredtopKeywordsSERPComparison.keywords[index][row] && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] < filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 2] && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] == -1">
                                    <vs-icon icon="schedule" size="small" color="primary" />
                                </span>


                                <!-- Chip inferior to previous and is != 0 -->
                                <vs-chip v-else-if="filteredtopKeywordsSERPComparison.keywords[index][row] && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] < filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 2] && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] != 0"
                                style="color: white; border-radius: 8px;width: 65px;" :color="computeResultColorFromDifference(8, 176, 185,filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1], true)">
                                    <span v-if="filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] == 101" style="font-size: 1rem;"><vs-icon icon="schedule" size="small" color="primary" /></span>
                                    <span v-else style="font-size: 1rem;">{{ filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] > 100 ? '100+' : filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] }}</span>
                                    <vs-icon icon-pack="feather" icon="icon-arrow-up" size="small" color="white" style="font-size: 1rem; height: 0.8rem;"></vs-icon>
                                </vs-chip>

                                <!-- Chip == 0 -->
                                <vs-chip v-else-if="filteredtopKeywordsSERPComparison.keywords[index][row] && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] == 0" style="color: white; border-radius: 8px;width: 65px;" color="grey">
                                    ABS
                                </vs-chip>
                                <!-- Chip == -1 -->
                                <span v-else-if="filteredtopKeywordsSERPComparison.keywords[index][row] && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] == -1"><vs-icon icon="schedule" size="small" color="primary" /></span>

                                <!-- Chip == previous -->
                                <vs-chip v-else-if="filteredtopKeywordsSERPComparison.keywords[index][row] && filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] == filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 2]"
                                style="color: white; border-radius: 8px;width: 65px;" :color="computeResultColorFromDifference(8, 176, 185,filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1], true)">
                                    <span v-if="filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] == 101" style="font-size: 1rem;"><vs-icon icon="schedule" size="small" color="primary" /></span>
                                    <span v-else style="font-size: 1rem;">{{ filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] > 100 ? '100+' : filteredtopKeywordsSERPComparison.keywords[index][row][filteredtopKeywordsSERPComparison.keywords[index][row].length - 1] }}</span>
                                </vs-chip>
                                <!-- else schedule -->
                                <span v-else><vs-icon icon="schedule" size="small" color="primary" /></span>
                                <vs-spacer />
                                </span>
                            </vs-td>
                        </vs-tr>
                        </template>
                    </vs-table>
                    <vs-pagination :total="totalPageTKSERP" v-model="currentPageTKSERPTable" class="w-full"></vs-pagination>
                    </vx-card>
                </div>
                </div>

            </vx-card>
        </div>
    </div>
</template>
<script>
import utilsMixin from "@/mixins/utilsMixin";
import VxTooltip from "../../../widgets/vx-tooltip/VxTooltip.vue";

export default {
	name: "KeywordsCompetitors",
	mixins: [utilsMixin],
	component: {VxTooltip},
	props: {
		competitorsLength: { // competitors.length
			type: Number,
			default: 0
		},
		topKeywordsLength: { // topKeywords.length
			type: Number,
			default: 0
		},
		/*
		 * maxRowMultiplicatorTKSERP: {
		 *     type: Number,
		 *     default: 0
		 * },
		 * keywordSearchInput: {
		 *     type: String,
		 *     default: ""
		 * },
		 */
		totalPageTKSERP: {
			type: Number,
			default: 0
		},
		seoValueByKeywordPreviousMonthWarning: {
			type: Boolean,
			default: false
		},
		societyName: { // selectedSociety.name
			type: String,
			default: ""
		},
		societyGscUrl: { // selectedSociety.name
			type: String,
			default: ""
		},
		stackedBarChartOptionsTopKeywordsCompetitorsComparison: {
			type: Object,
			default: null
		},
		topKeywordsSEOValueOptions: {
			type: Object,
			default: null
		},
		filteredtopKeywordsSERPComparison: {
			type: Object,
			default: null
		},
		totalRowTKSERP: {
			type: Number,
			default: 0
		},
		totalVolumeFilteredKeywordsCompetitors: {
			type: Number,
			default: 0
		},
		pageNumberOptions: {
			type: Array,
			default: () => []
		},
		competitors: {
			type: Array,
			default: () => []
		},
		competitorsFavicon: {
			type: Array,
			default: () => []
		},
		societyFavicon: {
			type: String,
			default: ""
		},
		serpComparisonSortKey: {
			type: String,
			default: ""
		},
		serpComparisonSortType: {
			type: String,
			default: ""
		}
	},
	watch: {
		keywordSearchInput: function(data){
			this.$emit("update-keyword-search-input", data);
		},
		maxRowMultiplicatorTKSERP: function(data){
			this.$emit("update-max-row-multiplicator-tk-serp", data);
		},
		currentPageTKSERPTable: function(data){
			this.$emit("update-competitor-table-value", data);
		}
	},
	data() {
		return {
			keywordSearchInput: "",
			maxRowMultiplicatorTKSERP: 25,
			currentPageTKSERPTable: 1
		};
	},
	methods: {
		computeResultColorFromDifferenceKD(r, g, b, r2, g2, b2, r3, b3, g3, value){
			let returnedColor = {
				r: 0,
				g: 0,
				b: 0
			};
			let maxKd = 100;
			let midKd = 50;
			let minKd = 0;
			if(value <= minKd){
				returnedColor.r = r;
				returnedColor.g = g;
				returnedColor.b = b;
			}
			else if(value <= midKd){
				let colorChangePercentage = ((value - minKd)) / (midKd - minKd);
				let colorMinMidDiff = {
					rdiff: r - r2,
					gdiff: g - g2,
					bdiff: b - b2
				};
				returnedColor.r = r - ((colorMinMidDiff.rdiff * colorChangePercentage));
				returnedColor.g = g - ((colorMinMidDiff.gdiff * colorChangePercentage));
				returnedColor.b = b - ((colorMinMidDiff.bdiff * colorChangePercentage));
			}
			else if(value >= maxKd){
				returnedColor.r = r3;
				returnedColor.g = g3;
				returnedColor.b = b3;
			}
			else{
				let colorChangePercentage = ((value - midKd)) / (maxKd - midKd);
				let colorMidMaxDiff = {
					rdiff: r2 - r3,
					gdiff: g2 - g3,
					bdiff: b2 - b3
				};
				returnedColor.r = r2 - ((colorMidMaxDiff.rdiff * colorChangePercentage));
				returnedColor.g = g2 - ((colorMidMaxDiff.gdiff * colorChangePercentage));
				returnedColor.b = b2 - ((colorMidMaxDiff.bdiff * colorChangePercentage));
			}
			return `rgb(${returnedColor.r}, ${returnedColor.g}, ${returnedColor.b})`;
		},
		showCompetitorsPopup(){
			this.$emit("show-competitor-popup");
		},
		sortTable(ref, key, key_output){
			let type = "asc";
			if(this.$refs[ref] && key == this.$props[key_output]){
				if(this.$refs[ref].currentSortType == "asc"){
					type = "desc";
				}
				else if(this.$refs[ref].currentSortType == "desc"){
					type = null;
				}

			}
			this.$emit("update-competitors-table-sort", [key, type]);
		},
		trimExtensionAndPrefix(url){
			let urlParts = url.length > 0 ? url.split(".") : [];
			if(urlParts.length >= 2){
				return urlParts[urlParts.length-2].charAt(0).toUpperCase() + urlParts[urlParts.length-2].slice(1);
			}
			else{
				return url.charAt(0).toUpperCase() + url.slice(1);
			}
		},
		faviconIsDownloaded(url, type="all"){
			if(type == "all"){
				if(url == this.getUrlDomain(this.$props.societyGscUrl)){
					return true;
				}
				else{
					type = "competitor";
				}
			}
			if(type == "competitor"){
				let foundCompetitorId = this.$props.competitors.findIndex(competitor => competitor == url);
				if(foundCompetitorId >= 0){

					let foundCompetitorImg = this.$props.competitorsFavicon[foundCompetitorId];
					if(foundCompetitorImg){
						if(foundCompetitorImg != ""){
							return true;
						}
					}
				}
			}
			if(type == "society"){
				if(url == this.getUrlDomain(this.$props.societyGscUrl)){
					return true;
				}
			}
			return false;
		},
		getFaviconSource(url, type="all"){
			if(type == "all"){

				if(url == this.getUrlDomain(this.$props.gsc_url)){
					return this.$props.societyFavicon;
				}
				else{
					type = "competitor";
				}
			}
			if(type == "competitor"){
				let foundCompetitorId = this.$props.competitors.findIndex(competitor => competitor == url);
				if(foundCompetitorId >= 0){
					let foundCompetitorImg = this.$props.competitorsFavicon[foundCompetitorId];
					if(foundCompetitorImg){
						if(foundCompetitorImg != ""){
							return foundCompetitorImg;
						}
					}
				}
			}
			if(type == "society"){
				return this.$props.societyFavicon;
			}
			return "";
		},
		selectEvolutionKeyword(keyword){
			this.$emit("select-evolution-keyword", keyword);
		},
		convertKeywordToGoogleSearchUrl(keyword){
			let baseUrl = "https://www.google.com/search?q=";
			let formatedKeyword = keyword.replace(/ /g, "+");
			return baseUrl + formatedKeyword;
		},
		computeDifferenceForOpacity(value, reverse = false){
			let differenceToCompute = ((value / 100) - 1) * 100;
			differenceToCompute = reverse ? differenceToCompute : differenceToCompute * -1;
			let returnOpacity = null;
			if(differenceToCompute >= 0){
				returnOpacity = 0.2;
			}
			else if(differenceToCompute < 0){
				differenceToCompute = differenceToCompute < -100 ? -100 : differenceToCompute;
				// 1. + 0.99134e^0.044018x
				returnOpacity = ((1 + 0.99134 * Math.exp(0.044018 * (differenceToCompute * -1))) + 20) / 100;
			}
			// //console.log(value, compareTo, differenceToCompute, returnOpacity)
			return returnOpacity;
		},

		computeResultColorFromDifference(r, g, b, value, isPosition){
			let opacity = this.computeDifferenceForOpacity(value, isPosition);
			return `rgba(${r}, ${g}, ${b}, ${opacity})`;
		},
		openLoadingContainer(containerId){
			//   //console.log("this.$refs[containerId]",containerId, this.$refs, this.$refs[containerId])
			if(this.$refs[containerId]){
				// //console.log("KeywordsCompetitors openLoadingContainer", containerId)
				this.$vs.loading({
					container: "#" + containerId
				});
			}
		},
		closeLoadingContainer(containerId){
			this.$vs.loading.close("#" + containerId + " > .con-vs-loading");
		}
	},
};
</script>
<style lang="scss" scoped>
th{
    width: auto !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    text-align: center;
}
td{
    width: auto !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
}
.td-chips{
    width: 50px !important; text-align:center !important;
}
.vx-row{
    width: auto !important;
    margin: 0 !important;
}
.hvr-underline-out{
  color: black;
}
.hvr-underline:hover{
  color:aqua;
  text-decoration: underline;
  cursor: pointer;
}
.txt_align_center {
  text-align: center !important;
}
.pointer {
  cursor: pointer;
}
.td_padding_top_bottom_small{
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}
</style>